export default "__VITE_ASSET__Bs_Gqlzr__"